export default {
  computed: {
    getUrlName() {
      return "privateZone"
    },
  },
}
